import * as actionType from './DVRhealthActionsType';
import Service from './service/DVRhealthService';

export const loadDVRs = (page, filters) => async dispatcher => {
  dispatcher({type: actionType.LOAD_REQUEST});
  try {
    const payload = await Service.loadDVRs(page, filters);
    dispatcher({type: actionType.LOAD_SUCCESS, payload});
  } catch (e) {
    dispatcher({type: actionType.LOAD_FAILURE});
    console.error(e);
  }
};

export const loadTotalDVRs = filters => async dispatcher => {
  dispatcher({type: actionType.LOAD_REQUEST});
  try {
    const payload = await Service.loadTotalDVRs(filters);
    dispatcher({type: actionType.LOAD_TOTALDVR_SUCCESS, payload});
  } catch (e) {
    dispatcher({type: actionType.LOAD_TOTALDVR_FAILURE});
    console.error(e);
  }
}

export const getReportURL = params => async dispatcher => {
  try {
    const payload = await Service.getReportURL(params);
    dispatcher({type: actionType.LOAD_REPORT_SUCCESS, payload});
  } catch (e) {
    dispatcher({type: actionType.LOAD_REPORT_FAILURE});
    console.error(e);
  }
};

export const unpairDvrOffline = (serialNo, filters) => async dispatcher => {
  try {
    await Service.unpairDvrOffline(serialNo);
    dispatcher({type: actionType.DVR_UNPAIR_SUCCESS});
    if (filters) {
      // time until ES index change;
      setTimeout(async () => {
        try {
          dispatcher({type: actionType.CLEAR});
          const payload = await Service.loadDVRs(0, filters);
          dispatcher({type: actionType.LOAD_SUCCESS, payload});
        } catch (e) {
          dispatcher({type: actionType.LOAD_FAILURE});
          console.error(e);
        }
      }, 500);
    }
  } catch (e) {
    dispatcher({type: actionType.DVR_UNPAIR_FAILURE});
    console.error(e);
  }
};

export const getCurrentSubscription = () => async dispatcher => {
  try {
    dispatcher({type: actionType.GET_SUBSCRIPTION_REQUEST});
    const currentSubscription = await Service.getCurrentSubscription();
    dispatcher({type: actionType.GET_SUBSCRIPTION_SUCCESS, payload: currentSubscription});
    return currentSubscription;
  } catch (e) {
    dispatcher({type: actionType.GET_SUBSCRIPTION_FAIL});
    console.error(e);
  }
};

export const subscribeForUpdates = (userEmail, subscriptionType) => async dispatcher => {
  try {
    dispatcher({type: actionType.SUBSCRIBE_REQUEST});
    const currentSubscription = await Service.subscribeForUpdates(userEmail, subscriptionType);

    dispatcher({type: actionType.SUBSCRIBE_SUCCESS, payload: currentSubscription});
    return currentSubscription;
  } catch (e) {
    dispatcher({type: actionType.SUBSCRIBE_FAIL});
    console.error(e);
  }
};

export const unsubscribeForUpdates = () => async dispatcher => {
  try {
    dispatcher({type: actionType.UNSUBSCRIBE_REQUEST});
    const currentSubscription = await Service.unsubscribeForUpdates();

    dispatcher({type: actionType.UNSUBSCRIBE_SUCCESS, payload: currentSubscription});
    return currentSubscription;
  } catch (e) {
    dispatcher({type: actionType.UNSUBSCRIBE_FAIL});
    console.error(e);
  }
};

export const clearReportFile = () => async dispatch => dispatch({type: actionType.CLEAR_REPORT_FILE});
export const clear = () => dispatcher => dispatcher({type: actionType.CLEAR});
